import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import tick_out from "../../assets/tick_outline.png";

const Confirm = (props) => {
  const createOrder = useSelector((state) => state?.orders?.createOrder);
  const history = useHistory();
  const orders = createOrder?.data?.orders || [];
  const orderNumbers = orders.map(o => o.order_number).filter(Boolean);


  useEffect(() => {
    return () => {
      props.resetOrder();
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="flex-center order-placed flex-col">
      <img src={tick_out} alt="tick" />
      <h3>Order Placed</h3>
      {/* <p>
        {Array.isArray(createOrder?.data?.orders)
          ? "Thank you for placing your orders "
          : `Thank you for placing your order. Your temporary order number is ${createOrder?.data?.order?.order_number
            ? createOrder?.data?.order?.order_number
            : ""
          }`}{" "}
        and you will receive a confirmation email shortly. If you have any questions please feel free to contact us.
      </p> */}
      <p>
        Thank you for placing your order{orderNumbers.length > 1 ? "s" : ""}.
        {orderNumbers.length > 0 && (
          <>
            {" "}Your order number{orderNumbers.length > 1 ? "s are" : " is"}{" "}
            <strong>{orderNumbers.join(", ")}</strong>.
          </>
        )}
        {" "} and You will receive a confirmation email shortly.  
        If you have any questions please feel free to contact us.
      </p>
      <br />
      <div className="btns">
        <button
          className="hm-btn"
          onClick={() => {
            history.push("/dashboard");
          }}
        >
          Home
        </button>
        <button
          className="view-btn"
          onClick={() => {
            if (Array.isArray(createOrder?.data?.orders)) {
              history.push("/orders");
            } else {
              history.push("/order-detail", {
                order_id: createOrder?.data?.order?.id,
                order_number: createOrder?.data?.order?.order_number
              });
            }
          }}
        >
          View order
        </button>
      </div>
    </div>
  );
};

export default Confirm;
